import { render } from "./AdminDashboardConfigurationView.vue?vue&type=template&id=963c95dc&scoped=true"
import script from "./AdminDashboardConfigurationView.vue?vue&type=script&lang=js"
export * from "./AdminDashboardConfigurationView.vue?vue&type=script&lang=js"

import "./AdminDashboardConfigurationView.vue?vue&type=style&index=0&id=963c95dc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963c95dc"]])

export default __exports__